<template>
  <sForm
    class="change-step menu"
    label-position="top">
    <template v-if="can_change_type">
      <sFormItem
        v-if="(!tender.bidStepType && tender.bidStepType !== 0) || change_type"
        :label="$t(`Tenders.ChooseStepApply`)"
        prop="type">
        <div>
          <div class="h8-text text-start pb-2">
            {{ $t(`Tenders.StepAppliesToAllLots`) }}
          </div>
          <sRadioGroup
            v-model="type"
            row
            @change="changeType">
            <sRadio
              data-qa="type-numerical"
              :label="1">
              {{ $t('Tenders.Numerical') }}
            </sRadio>
            <sRadio
              class="ml-2"
              data-qa="type-percentage"
              :label="0">
              {{ $t('Tenders.Percentage') }}
            </sRadio>
          </sRadioGroup>
        </div>
      </sFormItem>
      <div
        v-else
        class="mb-4 h7-text text-start to-change-type flex align-center"
        data-qa="change-step-to-type"
        @click="change_type = true, for_all = true">
        <sIcon
          class="mr-1"
          color="grey"
          size="16"
          type="edit"/>
        {{ $t(`Tenders.ChangeBidStep`) }}
      </div>
    </template>
    <div @click="change_type = false">
      <sFormItem
        :error="!!error ? error : ''"
        :label="$t('Tenders.StepBid')"
        prop="value">
        <sInputNumber
          ref="input"
          autofocus
          data-qa="change-step-input"
          :value="value"
          @update:value="changeValue"/>
        <template #error>
          <div
            class="secondary__red--text"
            data-qa="change-step-error">
            {{ error }}
          </div>
        </template>
      </sFormItem>
      <sFormItem
        :label="$t(`Tenders.ApplyAllItems`)"
        prop="for_all">
        <sRadioGroup
          v-model="for_all"
          class="mt-4"
          data-qa="change-step-apply-all"
          :disabled="!!change_type"
          row>
          <sRadio
            v-for="yesOrNoItem in yesOrNo"
            :key="yesOrNoItem.value"
            :data-qa="'change-step-apply-all-' + yesOrNoItem.value"
            :label="yesOrNoItem.value">
            {{ yesOrNoItem.label }}
          </sRadio>
        </sRadioGroup>
      </sFormItem>
      <sButton
        :disabled="!!error"
        @click="apply">
        {{ $t(`Common.Apply`) }}
      </sButton>
    </div>
  </sForm>
</template>
<script>
import { modalMixin, tenderMixin } from 'mixins'
import { mapGetters } from 'vuex'

export default {
  name: 'changeStepMenu',
  mixins: [ tenderMixin, modalMixin ],
  data() {
    return {
      for_all: false,
      value: '',
      type: 1, // (0 - процент, 1 - число)
      change_type: false,
      error: null,
      
      yesOrNo: [
        {value: true, label: this.$t('Tenders.Yes') },
        {value: false, label: this.$t('Tenders.No') },
      ],
    }
  },
  props: {
    step: [Object, Number, String],
    tender: Object,
    step_key: String,
    item: Object,
    activ: Boolean
  },
  created() {
    this.$set(this, 'value', this.step || '')

    this.$set(this, 'type', this.can_change_type ? this.tender.bidStepType : this.$can('set', 'bidStepType', 'PERCENT') ? 0 : 1)
  },
  computed: {
    ...mapGetters({
      tendersSettings: 'getTendersSettings',
    }),
    can_change_type() {
      return this.$can('set', 'bidStepType', 'CHOOSE')
    }
  },
  methods: {
    changeType() {
      this.value = ''
      this.findError()
    },
    changeValue(value) {
      this.value = value
      this.findError()
    },
    findError() {
      if (!this.value) {
        this.error = false
        return true
      }

      const normalizedValue = +this.normalizeNum(this.value || 0)

      if (isNaN(normalizedValue)) {
        return this.error = this.$t('Tenders.EnterCorectValue')
      }

      const { minBidStep, maxBidStep } = this.tendersSettings

      if (!this.type) {
        if (minBidStep > normalizedValue || maxBidStep < normalizedValue) {
          return this.error = `${this.$t('Tenders.EnterStepInRule')} ${minBidStep} ${this.$t('Common.till')} ${maxBidStep}`
        }
      } else if (this.item?.startAmount && normalizedValue > this.item.startAmount / 2) {
        return this.error = this.$t('Tenders.BiddingStepMoreThanStartingPrice')
      }

      this.error = false
      return true
    },
    apply() {
      const result = {
        allLot: this.for_all,
        type: this.type,
        value: null
      }
      if (this.for_all) {
        result.value = this.normalizeNum(this.value || 0)
      } else {
        if (this.tender.bidStepType != this.type) {
          result.value = this.normalizeNum(0)
        } else {
          this.value = +this.normalizeNum(this.value || 0).toFixed(2)
          result.value = this.value
        }
      }

      this.change_type = false
      this.$emit('change', result)
      this.$emit('update:activ', false)
    },
  },
  watch: {
    activ() {
      this.findError()
    }
  },
}
</script>
<style lang="scss" scoped>
.change-step {
  width: 400px;
  padding: 14px;
}
.input {
  width: 290px;
  max-width: 290px;
  .v-input__prepend-inner {
    margin: auto;
  }
}
.to-change-type {
  cursor: pointer;
}
</style>
